import Vue from 'vue';
import moment from 'moment-timezone';
// eslint-disable-next-line @typescript-eslint/no-var-requires
Vue.use(require('vue-moment'), { moment });
